import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TableCell,
    TableRow,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { useState } from "react";
import { OfferPositionCheckListItemDocumentsOverview } from "./OfferPositionCheckListItemDocumentsOverview";
import { IOfferPositionCheckListItem } from "../../interfaces/IOfferPositionCheckListItem";

import { Description } from "@mui/icons-material";

interface IProps {
    checkListItem: IOfferPositionCheckListItem;
    index: number;
    checkListItems: IOfferPositionCheckListItem[];
    setCheckListItems: Function;
}

export const OfferPositionCheckListItem: React.FC<IProps> = ({
    index,
    checkListItem,
    checkListItems,
    setCheckListItems,
}) => {
    const [isDocumentsOverviewOpen, setIsDocumentsOverviewOpen] = useState(false);
    const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const handleUploadStatusChange = (uploading: boolean) => {
        setIsUploading(uploading);
    };

    return (
        <>
            <Dialog open={isDocumentsOverviewOpen} onClose={() => {}} fullWidth maxWidth="md">
                <DialogTitle variant="h5">Dokumente verwalten - {checkListItem.title}</DialogTitle>
                <DialogContent>
                    <OfferPositionCheckListItemDocumentsOverview
                        checkListItem={checkListItem}
                        setCheckListItems={setCheckListItems}
                        checkListItems={checkListItems}
                        onUploadStatusChange={handleUploadStatusChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        disabled={isUploading}
                        variant="contained"
                        onClick={() => setIsDocumentsOverviewOpen(false)}
                        sx={{ marginLeft: "auto" }}
                    >
                        Schließen
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={isInfoDialogOpen} onClose={() => setIsInfoDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Beschreibung</DialogTitle>
                <DialogContent>{checkListItem.description || "Keine Beschreibung verfügbar."}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsInfoDialogOpen(false)} variant="contained" sx={{ ml: "auto" }}>
                        Schließen
                    </Button>
                </DialogActions>
            </Dialog>

            <TableRow key={index}>
                <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                        {checkListItem.title}
                    </Box>
                </TableCell>

                <TableCell>
                    <Button variant="contained" size="small" onClick={() => setIsInfoDialogOpen(true)}>
                        Info
                    </Button>
                </TableCell>

                <TableCell>
                    <Checkbox checked={checkListItem.isPhotoRequired} disabled />
                </TableCell>

                <TableCell>{checkListItem.document_objects.length}</TableCell>
                <TableCell>
                    <IconButton title="Dokumente verwalten" onClick={() => setIsDocumentsOverviewOpen(true)}>
                        <Description />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Checkbox
                        checked={checkListItem.isChecked}
                        disabled={checkListItem.isPhotoRequired ? !(checkListItem.document_objects.length > 0) : false}
                        onChange={(e) => {
                            const updatedCheckListItem: IOfferPositionCheckListItem = {
                                ...checkListItem,
                                isChecked: e.target.checked,
                            };
                            const updatedCheckListItems = checkListItems.map((item) =>
                                item.id === updatedCheckListItem.id ? updatedCheckListItem : item,
                            );

                            setCheckListItems(updatedCheckListItems);
                        }}
                    />
                </TableCell>
            </TableRow>
        </>
    );
};
